import List from './list'
import Prospective from './prospective'

export default function(prefix, app) {
  return app
    .useRouter(`${prefix}/list`, List)
    .useRouter(`${prefix}/prospective`, Prospective)
}
